(function() {
    class GiftWrapProduct extends HTMLElement {
        static lastChecked = null;
      
        constructor() {
          super();
      
          // Create the label element and set it as clickable
          this.label = document.createElement('label');
          this.label.style.cursor = 'pointer';
      
          // Create the checkbox input
          this.checkbox = document.createElement('input');
          this.checkbox.type = 'checkbox';
          this.checkbox.id = 'gift-wrap-checkbox';
          this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      
          // Append the checkbox to the label so that the whole label is clickable
          this.label.appendChild(this.checkbox);
      
          // Add label text
          const labelText = document.createElement('span');
          labelText.textContent = this.getAttribute('label') || 'Add Gift Wrap';
          this.label.appendChild(labelText);
      
          // Append the label to the custom element
          this.appendChild(this.label);
      
          this.sectionid = this.closest('.product-form').dataset.sectionid;
          this.sectionAtcId = this.closest('.product-form').dataset.generaid;
          this.mainatc = document.querySelector(`#AddToCart--${this.sectionAtcId}`);
          this.atc = document.querySelector(`#AddToCart--giftwrap${this.sectionAtcId}`);
    
          this.formId = this.mainatc.dataset.sectid;
          
          this.formm = document.getElementById(`ProductForm--${this.sectionid}`);
      
          this.mainatc.addEventListener('click', ()=>{
            setTimeout(()=>{this.atc.click()}, 600);
          })
        }
      
        connectedCallback() {
          // Find the "Add to Cart" button in the closest product form
          const productForm = this.closest('.product-form');
          if (productForm) {
            this.addToCartButton = productForm.querySelector('[type="submit"]');
            
            if (this.addToCartButton) {
              // Disable the button initially if no checkbox is checked
              this.updateButtonState();
      
              // Add an event listener for the button click
              this.addToCartButton.addEventListener('click', this.handleAddToCartClick.bind(this));
            }
          }
        }
      
        handleCheckboxChange() {
          const variantId = this.getAttribute('gift-variant-id'); // Gift wrap product variant ID
          const closestInput = this.closest('.product-form').querySelector('input[name="id"]');
          
      
          if (this.checkbox.checked) {
            // Uncheck the previously checked checkbox, if any
            if (GiftWrapProduct.lastChecked && GiftWrapProduct.lastChecked !== this) {
              GiftWrapProduct.lastChecked.checkbox.checked = false;
            }
      
            // Update the closest input[name="id"] with the gift wrap variant ID
            if (closestInput) {
              closestInput.value = variantId;
            }        
    
            this.formm.insertAdjacentHTML('beforeend', `<input class="pg_prop" type="hidden" name="properties[Gift Wrapped]" value="true" />`);
      
            // Update the last checked reference to this checkbox
            GiftWrapProduct.lastChecked = this;
          } else {
            this.formm.querySelector(`.pg_prop`).remove();
    
            // Clear the input[name="id"] if the checkbox is unchecked
            if (closestInput) {
              closestInput.value = '';
            }
            GiftWrapProduct.lastChecked = null;
          }
      
          // Update button state based on checkbox state
          this.updateButtonState();
        }
      
        handleAddToCartClick(event) {
          const productForm = this.closest('.product-form');
          const variantId = this.getAttribute('gift-variant-id');
          const closestInput = productForm.querySelector('input[name="id"]');
      
          // If the checkbox is checked, set the variant ID
          if (this.checkbox.checked && closestInput) {
            closestInput.value = variantId;
          }
        }
      
        updateButtonState() {
          if (this.addToCartButton) {
            // Disable the button if no checkbox is checked, enable it if one is checked
            this.addToCartButton.disabled = !this.checkbox.checked;
          }
        }
      }
      
      // Define the custom element
      customElements.define('gift-wrap-product', GiftWrapProduct);
})();